import {
  BILLING_SYSTEM_FORM_FETCH_REQUEST,
  BILLING_SYSTEM_FORM_FETCH_REQUEST_SUCCESS,
  BILLING_SYSTEM_FORM_FETCH_REQUEST_FAILURE,
  BILLING_SYSTEM_FORM_CLEAN_REQUEST,
  BILLING_SYSTEM_FORM_VERSIONS_FETCH_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: {},
  formVersions: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const billingSystemAddReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BILLING_SYSTEM_FORM_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BILLING_SYSTEM_FORM_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });
    case BILLING_SYSTEM_FORM_VERSIONS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        formVersions: action.data,
      });

    case BILLING_SYSTEM_FORM_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BILLING_SYSTEM_FORM_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        formVersions: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default billingSystemAddReducer;
